/**
 * Takes a date string that represents a UTC date and time
 * Returns a formatted version of the user's local time
 *
 * @param utcDateString - supports various formats. ex: "2024-07-11 15:15:58.875000", "2024-07-11T15:15:58.875000Z", "2024-07-11 14:51:28.078000+00:00", "2024-07-11 05:51:28.078000+00:00"
 * @returns formatted time string in the user's local timezone. ex: "9:15am", "9:15am", "8:51am", "11:51pm" (previous day locally)
 */
export function formatUtcToLocalTime(
    utcDateString?: string,
    includeSeconds: boolean = false,
): string {
    if (!utcDateString) return '';

    // Remove any characters after the timezone offset
    const cleanUtcDateString = utcDateString.split('+')[0].trim();

    // Ensure the date is parsed as UTC
    const utcDate = cleanUtcDateString.includes('T')
        ? new Date(cleanUtcDateString)
        : new Date(`${cleanUtcDateString.replace(' ', 'T')}Z`);

    // Extract local time components directly from the UTC date
    const localHours = utcDate.getHours();
    const minutes = utcDate.getMinutes();
    const seconds = utcDate.getSeconds();
    const ampm = localHours >= 12 ? 'pm' : 'am';
    const formattedLocalHours = localHours % 12 || 12; // Convert hour '0' to '12'

    // Format the local time string with optional seconds
    const formattedLocalTime = includeSeconds
        ? `${formattedLocalHours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}${ampm}`
        : `${formattedLocalHours}:${minutes.toString().padStart(2, '0')}${ampm}`;

    return formattedLocalTime;
}
